import React from 'react';
import Button from 'components/DesignSystem/Button';
import useSeasonalForecastDownload from 'hooks/Meteorology/Weather/SeasonalForecast/useSeasonalForecastDownload';

export default function SeasonalForecastToolbar({
  onInstructionsClick,
}: {
  onInstructionsClick: () => void;
}) {
  const { onDownloadClick, downloadDisabled } = useSeasonalForecastDownload();

  return (
    <div className="d-flex">
      <Button
        id="seasonal-forecast-download-button"
        small
        className="me-2"
        onClick={onDownloadClick}
        disabled={downloadDisabled}
        icon="download"
      />
      <Button
        id="seasonal-forecast-instructions-button"
        small
        onClick={onInstructionsClick}
        icon="help"
      />
    </div>
  );
}
